const configBoardTemplate = {
  notice: {
    listLayout: "BoardListDefaultLayout",
    filterLayout: "BoardFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",
  },
  noticeCreate: {
    writeLayouts: ["BoardWriteDefaultLayout"],
  },
  noticeUpdate: {
    writeLayouts: ["BoardWriteDefaultLayout"],
  },
  faq: {
    listLayout: "BoardListFaqLayout",
    filterLayout: "BoardFilterFaqLayout",
    paginationLayout: "PaginationDefaultLayout",
  },
  faqCreate: {
    writeLayouts: ["BoardWriteFaqLayout"],
  },
  faqUpdate: {
    writeLayouts: ["BoardWriteFaqLayout"],
  },
  qna: {
    listLayout: "BoardListQnaLayout",
    filterLayout: "BoardFilterQnaLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  },
  qnaCreate: {
    writeLayouts: ["BoardWriteQnaLayout"],
  },
  qnaUpdate: {
    writeLayouts: ["BoardWriteQnaLayout"],
  },
  event: {
    listLayout: "BoardListEventLayout",
    filterLayout: "BoardFilterDefaultLayout",
    paginationLayout: "PaginationDefaultLayout",
  },
  eventCreate: {
    writeLayouts: ["BoardWriteEventLayout"],
  },
  eventUpdate: {
    writeLayouts: ["BoardWriteEventLayout"],
  },

  userContent: {
    listLayout: "BoardListUserContentLayout",
    filterLayout: "BoardFilterUserContentLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  },
  userContentDetail: {
    detailLayout: "BoardDetailUserContentLayout",
  },
  userContentCommentList: {
    commentListLayout: "CommentListDefaultLayout",
    commentPaginationLayout: "CommentPaginationDefaultLayout",
  },
  ktalkContent: {
    listLayout: "BoardListUserContentLayout",
    filterLayout: "BoardFilterUserContentLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  },
  ktalkContentDetail: {
    detailLayout: "BoardDetailUserContentLayout",
  },
  ktalkContentCommentList: {
    commentListLayout: "CommentListDefaultLayout",
    commentPaginationLayout: "CommentPaginationDefaultLayout",
  },
  userCommentReplyList: {
    commentListLayout: "CommentPopupListLayout",
    commentPaginationLayout: "CommentPaginationDefaultLayout",
  },
  ktalkCommentReplyList: {
    commentListLayout: "CommentPopupListLayout",
    commentPaginationLayout: "CommentPaginationDefaultLayout",
  },
  mail: {
    listLayout: "BoardListMailLayout",
    filterLayout: "BoardFilterMailLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  },
  mailSend: {
    writeLayouts: ["BoardWriteMailLayout"],
  },
  mailDetail: {
    writeLayouts: ["BoardWriteMailLayout"],
  },
  userContentSelect: {
    listLayout: "BoardListUserContentSelectLayout",
    filterLayout: "BoardFilterUserContentLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  },
  noticeSelect: {
    listLayout: "BoardListNoticeLayout",
    filterLayout: "BoardFilterDefaultLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  },
  productSelect: {
    listLayout: "BoardListProductLayout",
    filterLayout: "BoardFilterProductLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  },
  eventSelect: {
    listLayout: "BoardListEventSelectLayout",
    filterLayout: "BoardFilterDefaultLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  },
  ssamsContent: {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsContentLayout",
    paginationLayout: "PaginationDefaultLayout",
  },
  ssamsContentDetail: {
    detailLayout: "BoardDetailSsamsContentLayout",
  },
  ssamsContentCommentList: {
    commentListLayout: "CommentListDefaultLayout",
    commentPaginationLayout: "CommentPaginationDefaultLayout",
  },
  ssamsKoreanTalk: {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsQnaLayout",
    paginationLayout: "PaginationDefaultLayout",
  },
  ssamsKoreanTalkDetail: {
    detailLayout: "BoardDetailSsamsContentLayout",
  },
  ssamsKoreanTalkCommentList: {
    commentListLayout: "CommentListDefaultLayout",
    commentPaginationLayout: "CommentPaginationDefaultLayout",
  },
  ssamsFix: {
    listLayout: "BoardListSsamsContentLayout",
  },
  ssamsContentFix : {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsContentLayout",
    paginationLayout: "PaginationNoDeleteLayout",

  },
  ssamsKoreanTalkFix : {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsContentLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  },
  contentFix : {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsContentLayout",
    paginationLayout: "PaginationDefaultLayout",
  },
  ktalkFix : {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsContentLayout",
    paginationLayout: "PaginationDefaultLayout",
  },
  ktalkFixModal : {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsContentLayout",
    paginationLayout: "PaginationNoDeleteLayout",

  },
  contentFixModal : {
    listLayout: "BoardListSsamsContentLayout",
    filterLayout: "BoardFilterSsamsContentLayout",
    paginationLayout: "PaginationNoDeleteLayout",
  }

};

export default {
    methods: {
        returnBoardTemplateConfig(type) {
            return configBoardTemplate[type];
        }
    },
}
